import { Outlet, Link } from "react-router-dom";
import React, { useEffect, useState } from 'react';

const Layout = () => {
  const [userId, setUserId] = useState(false);
  useEffect(() => {
      const fetchData = async () => {
          const response = await fetch('/jobs');
          const data = await response.json();
          setUserId(data.userId);
      }
      fetchData();
  });

  // return isAuthed ? (<div>
  //     <h1>Home</h1>
  //     <p>You are logged in</p>
  // </div>) : (<div>
  //     <h1>Home</h1>
  //     <a className="button google" href="/login/federated/google">
  //         <i className="fab fa-google"></i> Sign in with Google
  //     </a>
  // </div>);
  const jobsLink = userId ? 
    (
      <li className="navbar-item">
        <Link className="nav-link" to="/jobs">Jobs</Link>
      </li>
    ) : "";
  const logoutLink = userId ? 
    (
      <form className="form-inline" action="/logout" method="post">
        <button className="logout btn" type="submit">Sign out</button>
        <input type="hidden" id="token" name="_csrf" value="" />
      </form>
    ) : "";

  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <ul className="navbar-nav mr-auto">
          <li className="navbar-item">
            <Link className="nav-link" to="/">Home</Link>
          </li>
          {jobsLink}
        </ul>
        {logoutLink}
      </nav>

      <Outlet context={[userId, setUserId]}/>
    </div>
  )
};

export default Layout;